import { Lock } from "@phosphor-icons/react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";

import { EditCollaboratorForm } from "@/components";
import type { ModalProps } from "@/shared.types";
import type { Collaborator } from "@/types";
import { Circle, Heading, Modal } from "@/ui";

interface LocationState {
  collaborator: Collaborator;
  partnerId: string;
}

export const EditCollaboratorModal = ({ show, onClose }: ModalProps) => {
  const location = useLocation();
  const state = location.state as LocationState;
  const collaborator = state?.collaborator;
  const partnerId = state?.partnerId;

  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading={t("partner.edit_general_info")}
            left={
              <Circle>
                <Lock size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <EditCollaboratorForm
        onClose={onClose}
        partnerId={partnerId}
        initialCollaborator={collaborator}
      />
    </Modal>
  );
};
